/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface EmployerEnrichmentResponse {
  mission_vision?: string | null;
  funding_traction?: string | null;
  culture_principles?: string | null;
  benefits?: string | null;
}
